/**
 * @desc 修改季度分计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanQuarterCommonUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/quarter/updatePartPlan',
    data,
  });
}

export function mock(
  data: defs.PlanQuarterCommonUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/quarter/updatePartPlan',
    data,
  });
}
